var PrescriptionSide;
(function(PrescriptionSide) {
    PrescriptionSide["Right"] = 'rightEye';
    PrescriptionSide["Left"] = 'leftEye';
})(PrescriptionSide || (PrescriptionSide = {}));
var PrescriptionKey;
(function(PrescriptionKey) {
    PrescriptionKey["Power"] = 'power';
    PrescriptionKey["Axis"] = 'axis';
    PrescriptionKey["Cylinder"] = 'cylinder';
    PrescriptionKey["Addition"] = 'addition';
    PrescriptionKey["BaseCurve"] = 'baseCurve';
    PrescriptionKey["Diameter"] = 'diameter';
    PrescriptionKey["PupillaryDistance"] = 'pupillaryDistance';
    PrescriptionKey["Prism"] = 'prism';
    PrescriptionKey["Dominance"] = 'dominance';
})(PrescriptionKey || (PrescriptionKey = {}));
var Validity;
(function(Validity) {
    Validity[Validity["VALID"] = 1] = "VALID";
    Validity[Validity["INVALID"] = 0] = "INVALID";
})(Validity || (Validity = {}));
var PrescriptionType;
(function(PrescriptionType) {
    PrescriptionType["EXISTING_CUSTOMER"] = 'ExistingCustomer';
    PrescriptionType["NEW_PRESCRIPTION"] = 'NewPrescription';
    PrescriptionType["PRESCRIPTION_FILE"] = 'PrescriptionFile';
    PrescriptionType["EMAIL_PRESCRIPTION"] = 'EmailPrescription';
    PrescriptionType["OCR_PRESCRIPTION"] = 'OCRPrescription';
    PrescriptionType["PRESCRIPTION_WITH_MANUAL_XOR_FILE_PUPILLARY_DISTANCE"] = 'PrescriptionWithManualXORFilePupillaryDistance';
})(PrescriptionType || (PrescriptionType = {}));

export { PrescriptionKey, PrescriptionSide, PrescriptionType, Validity };
//# sourceMappingURL=prescription.js.map
